module.exports = {
  template: require('./appointments-list-container.pug')()
  controller: require('./appointments-list-container.ctrl')
}
